<template>
  <div id="history-screen" translate="no">
    <Loading
      :active="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      :height="40"
      loader="spinner"
      color="#003340"
    ></Loading>
    <BackToServices
      :table="tableId"
      :storeName="storeName"
      :isApplication="isApplication"
      :hasBoxShadow="true"
      :amountOfDepartments="2"
      :goBackToOpenTables="false"
      :pdaMobileScreen="false"
      :restaurantType="'HISTORY'"
      id="back-to-services"
    ></BackToServices>
    <div id="banner">
      <img v-if="store" id="banner-image" :src="`${store.bannerLink}`" alt />

      <div id="store-info">
        <Store id="store" :store="store" :shouldShowMenu="false"></Store>
      </div>

      <div id="upper-bar">
        <div id="logo-container" v-if="!isApplication">
          <a id="link-to-landing" href>
            <img id="logo" src="../../assets/Full_logo-Black.svg" alt />
          </a>
        </div>
        <div id="profile-and-cart">
          <LanguageSelect
            id="language-select"
            :class="{ 'language-position-in-login': isLoggedIn }"
          ></LanguageSelect>

          <ProfileDropdown
            v-if="isLoggedIn"
            id="profile-dropdown"
            :isApplication="isApplication"
            :class="{ 'profile-dropdown-with-lang-select': isAbleToChangeLanguage,
                    'profile-dropdown-without-lang-select': !isAbleToChangeLanguage }"
          ></ProfileDropdown>
          <EnterPrompt
            v-else-if="shouldShowEnterPrompt && !isLoggedIn && !isApplication"
            @enter-clicked="initiateEntrance"
            id="enter-prompt"
            :class="{ 'enter-prompt-with-lang-select': isAbleToChangeLanguage,
                    'enter-prompt-without-lang-select': !isAbleToChangeLanguage }"
          ></EnterPrompt>
        </div>
      </div>
    </div>
    <h6 v-if="waiterOfcurrentUser" id="connected-user-container">
      Είστε συνδεδεμένος ως:
      <span id="name-of-connected-user">{{waiterOfcurrentUser.name}}</span>
    </h6>
    <div
      id="history-results-container"
      v-if="isLoggedIn && waiterOfcurrentUser!=null && waiterOfcurrentUser.ableToSeeMobileReports && !isLoading"
    >
      <div id="select-filter-container">
        <div id="type-of-reports-container">
          <button
            @click="setTypeOfReport('ACCOUNTS')"
            class="report-type-selection-button"
            :class="{ 'selected-report-type': typeOfReport=='ACCOUNTS'}"
          >Λογαριασμοί</button>
          <button
            @click="setTypeOfReport('ACTIONS')"
            class="report-type-selection-button"
            :class="{ 'selected-report-type': typeOfReport=='ACTIONS'}"
          >Πληρωμές</button>
          <button
            @click="setTypeOfReport('CLOSED_TABLES')"
            class="report-type-selection-button"
            :class="{ 'selected-report-type': typeOfReport=='CLOSED_TABLES'}"
          >Κλειστά</button>
          <button
            v-if="waiterOfcurrentUser && waiterOfcurrentUser.ableToSeeStats"
            @click="setTypeOfReport('STATS')"
            class="report-type-selection-button"
            :class="{ 'selected-report-type': typeOfReport=='STATS'}"
          >Στατιστικά</button>
        </div>

        <div class="label-and-name" v-if="restaurantsWithTableOpenings.length>1">
          <div class="label">
            <h6 class="filter-title">{{labels.tableOpenings.department[language]}}</h6>
            <select
              id="select-department-dropdown"
              @change="onDepartmentChange()"
              style="width:167px"
              v-model="selectedDepartmentId"
            >
              <option v-if="typeOfReport!='STATS'" :value="null">Όλα</option>
              <option
                v-for="restaurant in restaurantsWithTableOpenings"
                :key="restaurant.id"
                :value="restaurant.id"
              >{{restaurant.names.translation[language].name }}</option>
            </select>
          </div>
        </div>

        <div
          class="label-and-name"
          style="margin-top: 2px !important;"
          v-if="typeOfReport=='STATS'"
        >
          <div class="label">
            <h6 class="filter-title no-bottom-margin">Τύπος</h6>
            <select
              class="no-bottom-margin"
              id="select-type-of-sales-dropdown"
              @change="onTypeOfSalesChange()"
              style="width:214px"
              v-model="typeOfSales"
            >
              <option value="ALL_WITHOUT_CANCELED">Όλα - χωρίς ακυρώσεις</option>
              <option value="CANCELED">Ακυρωμένα</option>
              <option value="TREATED">Κερασμένα</option>
            </select>
          </div>
        </div>

        <div
          v-if="typeOfReport=='ACCOUNTS' || typeOfReport=='ACTIONS' || typeOfReport=='CLOSED_TABLES'"
          class="label-and-name"
          style="margin-top: 2px !important"
        >
          <div class="label" style="margin-right:10px">
            <h6
              class="filter-title no-bottom-margin"
            >{{labels.tableOpenings.typeOfTable[language]}}:</h6>
            <select
              @change="adaptTables()"
              style="width:214px"
              class="no-bottom-margin"
              v-model="tableType"
            >
              <option value="ALL">Όλα</option>
              <option value="TABLES">{{labels.table.tables[this.language]}}</option>
              <option
                v-if="store && store.hotel"
                value="ROOMS"
              >{{labels.table.rooms[this.language]}}</option>
              <option value="DELIVERY">Delivery</option>
              <option value="TAKE_AWAY">Takeaway | Self service</option>
            </select>
          </div>
        </div>

        <div
          v-if="tableSections.length>0 && (typeOfReport=='ACCOUNTS' || typeOfReport=='ACTIONS' || typeOfReport=='CLOSED_TABLES')"
          class="label-and-name"
          style="margin-top: 8px !important"
        >
          <div class="label" style="margin-right:10px">
            <h6 class="filter-title no-bottom-margin">Πόστο:</h6>
            <select
              @change="adaptTables()"
              style="width:214px"
              class="no-bottom-margin"
              v-model="selectedSection"
            >
              <option :value="null">Όλα</option>
              <option
                v-for="(section, index) in tableSections"
                :key="index"
                :value="section"
              >{{section}}</option>
            </select>
          </div>
        </div>

        <div class="label-and-name" style="margin-top: 8px !important">
          <div class="label" style="margin-right:10px">
            <h6 class="filter-title no-bottom-margin">Θέση:</h6>
            <select style="width:214px" class="no-bottom-margin" v-model="selectedTableId">
              <option :value="null">Όλα</option>
              <option
                :key="table.id"
                :value="table.id"
                v-for="table in tablesToShowForSelection"
              >{{table.tableNumber}}</option>
            </select>
          </div>
        </div>

        <div v-if="typeOfReport=='STATS'" class="label-and-name" style="margin-top: 8px !important">
          <div class="label" style="margin-right:10px">
            <h6 class="filter-title no-bottom-margin">Από:</h6>
            <select style="width:214px" class="no-bottom-margin" v-model="orderOrigin">
              <option :value="null">Όλα</option>
              <option value="PDA">Προσωπικό</option>
              <option value="CUSTOMER">Πελάτες (QR Code)</option>
            </select>
          </div>
        </div>

        <div
          v-if="waiterOfcurrentUser && waiterOfcurrentUser.orderHistoryScope!='PERSONAL_TODAY'"
          class="label-and-name"
          :class="{ 'low-visibility': typeOfReport=='STATS' && orderOrigin=='CUSTOMER'}"
        >
          <div class="label" style="margin-right:10px">
            <h6 class="filter-title no-bottom-margin">Χρήστης:</h6>
            <select
              :disabled="typeOfReport=='STATS' && orderOrigin=='CUSTOMER'"
              style="width:190px"
              class="no-bottom-margin"
              v-model="waiterToSearch"
            >
              <option :value="null">Όλοι</option>
              <option
                v-for="waiter in waitersToShow"
                :key="waiter.userId"
                :value="waiter.userId"
              >{{waiter.name}} {{waiter.deactivated ? '(Ανενεργός)': ''}}</option>
            </select>
          </div>
        </div>

        <div
          class="label-and-name margin-top-12"
          v-if="waiterOfcurrentUser && waiterOfcurrentUser.orderHistoryScope=='ALL'"
        >
          <div class="label" style="margin-right:10px">
            <h6 class="filter-title no-bottom-margin" style="margin-right:6px">Από</h6>
            <date-picker
              @change="clearErrors()"
              @pick="clearErrors()"
              style="width:230px"
              type="datetime"
              v-model="startingDate"
              :time-picker-options="timePickerOptions"
              time-title-format="DD MMM YYYY"
              format="ddd DD MMM YYYY | HH:mm"
              placeholder="Select date and time"
              :show-second="false"
            ></date-picker>
          </div>
        </div>
        <div
          class="label-and-name"
          v-if="waiterOfcurrentUser && waiterOfcurrentUser.orderHistoryScope=='ALL'"
        >
          <div class="label" style="margin-right:10px">
            <h6 class="filter-title no-bottom-margin" style="margin-right:6px">Εώς</h6>
            <date-picker
              @change="clearErrors()"
              @pick="clearErrors()"
              style="width:230px"
              type="datetime"
              v-model="endingDate"
              :time-picker-options="timePickerOptions"
              time-title-format="DD MMM YYYY"
              format="ddd DD MMM YYYY | HH:mm"
              placeholder="Select date and time"
              :show-second="false"
            ></date-picker>
          </div>
        </div>
        <div id="actions-buttons-container">
          <button id="search-history-btn" @click="getReports()">Αναζήτηση</button>
        </div>
        <p v-if="error" id="error-message">{{errorMessage}}</p>
      </div>

      <div
        v-if="(typeOfReport=='ACCOUNTS' || typeOfReport=='ACTIONS') && !searching"
        class="prices-results-container"
      >
        <div v-if="adminsWithSales.length>0" class="all-users-and-print-container">
          <h6 class="all-users">Όλοι οι χρήστες</h6>

          <button
            @click="sendAdminSalesForPrint(pricesOfClosed, 0)"
            class="print-sales-button action-button"
          >
            <clip-loader
              v-if="printingUserSales==0"
              :loading="printingUserSales==0"
              size="16px"
              color="#ffffff"
            />
            <font-awesome-icon v-else icon="print" />
          </button>
        </div>

        <div v-if="adminsWithSales.length==0" class="all-users-and-print-container">
          <h6
            v-if="typeOfReport=='ACCOUNTS'"
            class="amount-of-closed"
          >{{totalAmountOfClosed}} {{totalAmountOfClosed==1?'Λογαριασμός': 'Λογαριασμοί'}}</h6>
          <h6 v-if="typeOfReport=='ACTIONS'" class="amount-of-closed">Πληρωμές/Ταμεία</h6>
          <button
            @click="sendAdminSalesForPrint(pricesOfClosed, 0)"
            class="print-sales-button action-button"
            style="margin-bottom: 0px !important"
          >
            <clip-loader
              v-if="printingUserSales==0"
              :loading="printingUserSales==0"
              size="16px"
              color="#ffffff"
            />
            <font-awesome-icon v-else icon="print" />
          </button>
        </div>
        <h6
          v-else-if="typeOfReport=='ACCOUNTS'"
          class="amount-of-closed"
        >{{totalAmountOfClosed}} {{totalAmountOfClosed==1?'Λογαριασμός': 'Λογαριασμοί'}}</h6>
        <h6 v-else-if="typeOfReport=='ACTIONS'" class="amount-of-closed">Πληρωμές/Ταμεία</h6>

        <h6
          class="total-price-of-closed"
        >Σύνολο: {{waiterOfcurrentUser!=null && waiterOfcurrentUser.ableToSeeBlackMoney ? getTotalPriceFixed(pricesOfClosed) : getTotalPriceForReceiptsFixed(pricesOfClosed)}}€</h6>
        <h6 class="payment-method-price">
          <font-awesome-icon style="color: #198b4a" icon="money-bill" />
          Μετρητά: {{ waiterOfcurrentUser!=null && waiterOfcurrentUser.ableToSeeBlackMoney ? (pricesOfClosed !=null && pricesOfClosed.amountPayedByCash!=null ? pricesOfClosed.amountPayedByCash.toFixed(2) : '0.00') : (pricesOfClosed !=null && pricesOfClosed.amountOfCashReceipts!=null ? pricesOfClosed.amountOfCashReceipts.toFixed(2) : '0.00')}}€
        </h6>
        <h6 class="payment-method-price">
          <font-awesome-icon style="color: #17a2b8" icon="credit-card" />
          Κάρτα: {{ waiterOfcurrentUser!=null && waiterOfcurrentUser.ableToSeeBlackMoney ? (pricesOfClosed !=null && pricesOfClosed.amountPayedByCard!=null ? pricesOfClosed.amountPayedByCard.toFixed(2) : '0.00') : (pricesOfClosed !=null && pricesOfClosed.amountOfCardReceipts!=null ? pricesOfClosed.amountOfCardReceipts.toFixed(2) : '0.00')}}€
        </h6>
        <h6 v-if="store && store.hotel" class="payment-method-price">
          <font-awesome-icon style="color: #003340" icon="bed" />
          Room charge: {{ waiterOfcurrentUser!=null && waiterOfcurrentUser.ableToSeeBlackMoney ? (pricesOfClosed !=null && pricesOfClosed.amountChargedToRoom!=null ? pricesOfClosed.amountChargedToRoom.toFixed(2) : '0.00') : '0.00'}}€
        </h6>
        <h6 class="payment-method-price">
          <font-awesome-icon style="color: #efb400" icon="history" />
          Επί πιστώσει: {{waiterOfcurrentUser!=null && waiterOfcurrentUser.ableToSeeBlackMoney ? (pricesOfClosed !=null && pricesOfClosed.amountOnCredit!=null ? pricesOfClosed.amountOnCredit.toFixed(2) : '0.00') : (pricesOfClosed !=null && pricesOfClosed.amountOfOnCreditReceipts!=null ? pricesOfClosed.amountOfOnCreditReceipts.toFixed(2) : '0.00')}}€
        </h6>
        <h6 class="payment-method-price">
          <font-awesome-icon style="color: #198b4a" icon="percent" />
          Εκπτώσεις: {{pricesOfClosed !=null && pricesOfClosed.amountOfDiscounts!=null ? pricesOfClosed.amountOfDiscounts.toFixed(2) : '0.00'}}€
        </h6>
        <h6 class="payment-method-price">
          <font-awesome-icon style="color: #6f2c91" icon="gift" />
          Κερασμένα: {{waiterOfcurrentUser!=null && waiterOfcurrentUser.ableToSeeBlackMoney ? (pricesOfClosed !=null && pricesOfClosed.amountTreated!=null ? pricesOfClosed.amountTreated.toFixed(2) : '0.00') : (pricesOfClosed !=null && pricesOfClosed.amountOfSelfDeliveryReceipts!=null ? pricesOfClosed.amountOfSelfDeliveryReceipts.toFixed(2) : '0.00')}}€
        </h6>
        <h6 class="payment-method-price">
          <font-awesome-icon style="color: #d9534f" icon="trash" />
          Ακυρωμένα: {{pricesOfClosed !=null && pricesOfClosed.amountCanceled!=null ? pricesOfClosed.amountCanceled.toFixed(2) : '0.00'}}€
        </h6>
        <h6 class="payment-method-price">
          <font-awesome-icon style="color: #198b4a; margin-bottom:2px" icon="hand-holding-usd" />
          Tips καρτών: {{pricesOfClosed !=null && pricesOfClosed.totalCardtips!=null ? pricesOfClosed.totalCardtips.toFixed(2) : '0.00'}}€
        </h6>
      </div>

      <div
        v-if="(typeOfReport=='ACCOUNTS' || typeOfReport=='ACTIONS') && isAtLeastOneRestaurantPublishesReceipt && !searching && waiterOfcurrentUser && waiterOfcurrentUser.ableToSeeReceiptsWithPayments"
        class="receipts-results-container"
      >
        <h6 class="amount-of-closed">
          <font-awesome-icon style="color: #003340; margin-right:6px" icon="receipt" />Αποδείξεις
        </h6>
        <h6
          class="total-price-of-closed"
        >Σύνολο: {{getTotalPriceForReceiptsFixed(pricesOfClosed)}}€ | ΦΠΑ: {{pricesOfClosed !=null && pricesOfClosed.amountOfVat!=null ? pricesOfClosed.amountOfVat.toFixed(2) : '0.00'}}€</h6>
        <h6 class="payment-method-price">
          <font-awesome-icon style="color: #198b4a" icon="money-bill" />
          Μετρητά: {{pricesOfClosed !=null && pricesOfClosed.amountOfCashReceipts!=null ? pricesOfClosed.amountOfCashReceipts.toFixed(2) : '0.00'}}€
        </h6>
        <h6 class="payment-method-price">
          <font-awesome-icon style="color: #17a2b8" icon="credit-card" />
          Κάρτα: {{pricesOfClosed !=null && pricesOfClosed.amountOfCardReceipts!=null ? pricesOfClosed.amountOfCardReceipts.toFixed(2) : '0.00'}}€
        </h6>
        <h6 class="payment-method-price">
          <font-awesome-icon style="color: #efb400" icon="history" />
          Επί πιστώσει: {{pricesOfClosed !=null && pricesOfClosed.amountOfOnCreditReceipts!=null ? pricesOfClosed.amountOfOnCreditReceipts.toFixed(2) : '0.00'}}€
        </h6>
        <h6 class="payment-method-price">
          <font-awesome-icon style="color: #6f2c91" icon="gift" />
          Αυτοπαραδόσεις: {{pricesOfClosed !=null && pricesOfClosed.amountOfSelfDeliveryReceipts!=null ? pricesOfClosed.amountOfSelfDeliveryReceipts.toFixed(2) : '0.00'}}€
        </h6>
      </div>

      <div
        v-if="(typeOfReport=='ACCOUNTS' || typeOfReport=='ACTIONS') && adminsWithSales.length>0 && !searching"
      >
        <div
          class="admin-with-sales-container"
          v-for="adminWithSales in adminsWithSales"
          :key="adminWithSales.userId"
        >
          <div class="user-and-print-container">
            <h6 class="name-of-user">{{getWaiterNameWithDeactivatedStatus(adminWithSales.userId)}}</h6>

            <button
              @click="sendAdminSalesForPrint(adminWithSales.prices, adminWithSales.userId)"
              class="print-sales-button action-button"
            >
              <clip-loader
                v-if="printingUserSales==adminWithSales.userId"
                :loading="printingUserSales==adminWithSales.userId"
                size="16px"
                color="#ffffff"
              />
              <font-awesome-icon v-else icon="print" />
            </button>
          </div>

          <div class="prices-results-container">
            <h6
              class="total-price-of-closed"
            >Σύνολο: {{waiterOfcurrentUser!=null && waiterOfcurrentUser.ableToSeeBlackMoney ? getTotalPriceFixed(adminWithSales.prices) : getTotalPriceForReceiptsFixed(adminWithSales.prices)}}€</h6>
            <h6 class="payment-method-price">
              <font-awesome-icon style="color: #198b4a" icon="money-bill" />
              Μετρητά: {{waiterOfcurrentUser!=null && waiterOfcurrentUser.ableToSeeBlackMoney ? (adminWithSales.prices !=null && adminWithSales.prices.amountPayedByCash!=null ? adminWithSales.prices.amountPayedByCash.toFixed(2) : '0.00') : (adminWithSales.prices !=null && adminWithSales.prices.amountOfCashReceipts!=null ? adminWithSales.prices.amountOfCashReceipts.toFixed(2) : '0.00')}}€
            </h6>
            <h6 class="payment-method-price">
              <font-awesome-icon style="color: #17a2b8" icon="credit-card" />
              Κάρτα: {{waiterOfcurrentUser!=null && waiterOfcurrentUser.ableToSeeBlackMoney ? (adminWithSales.prices !=null && adminWithSales.prices.amountPayedByCard!=null ? adminWithSales.prices.amountPayedByCard.toFixed(2) : '0.00') : (adminWithSales.prices !=null && adminWithSales.prices.amountOfCardReceipts!=null ? adminWithSales.prices.amountOfCardReceipts.toFixed(2) : '0.00')}}€
            </h6>
            <h6 v-if="store && store.hotel" class="payment-method-price">
              <font-awesome-icon style="color: #003340" icon="bed" />
              Room charge: {{waiterOfcurrentUser!=null && waiterOfcurrentUser.ableToSeeBlackMoney ? (adminWithSales.prices !=null && adminWithSales.prices.amountChargedToRoom!=null ? adminWithSales.prices.amountChargedToRoom.toFixed(2) : '0.00') : '0.00'}}€
            </h6>
            <h6 class="payment-method-price">
              <font-awesome-icon style="color: #efb400" icon="history" />
              Επί πιστώσει: {{waiterOfcurrentUser!=null && waiterOfcurrentUser.ableToSeeBlackMoney ? (adminWithSales.prices !=null && adminWithSales.prices.amountOnCredit!=null ? adminWithSales.prices.amountOnCredit.toFixed(2) : '0.00') : (adminWithSales.prices !=null && adminWithSales.prices.amountOfOnCreditReceipts!=null ? adminWithSales.prices.amountOfOnCreditReceipts.toFixed(2) : '0.00')}}€
            </h6>
            <h6 class="payment-method-price">
              <font-awesome-icon style="color: #198b4a" icon="percent" />
              Εκπτώσεις: {{adminWithSales.prices !=null && adminWithSales.prices.amountOfDiscounts!=null ? adminWithSales.prices.amountOfDiscounts.toFixed(2) : '0.00'}}€
            </h6>
            <h6 class="payment-method-price">
              <font-awesome-icon style="color: #6f2c91" icon="gift" />
              Κερασμένα: {{waiterOfcurrentUser!=null && waiterOfcurrentUser.ableToSeeBlackMoney ? (adminWithSales.prices !=null && adminWithSales.prices.amountTreated!=null ? adminWithSales.prices.amountTreated.toFixed(2) : '0.00') : (adminWithSales.prices !=null && adminWithSales.prices.amountOfSelfDeliveryReceipts!=null ? adminWithSales.prices.amountOfSelfDeliveryReceipts.toFixed(2) : '0.00')}}€
            </h6>
            <h6 class="payment-method-price">
              <font-awesome-icon style="color: #d9534f" icon="trash" />
              Ακυρωμένα: {{adminWithSales.prices !=null && adminWithSales.prices.amountCanceled!=null ? adminWithSales.prices.amountCanceled.toFixed(2) : '0.00'}}€
            </h6>
            <h6 class="payment-method-price">
              <font-awesome-icon style="color: #198b4a; margin-bottom:2px" icon="hand-holding-usd" />
              Tips καρτών: {{adminWithSales.prices !=null && adminWithSales.prices.totalCardtips!=null ? adminWithSales.prices.totalCardtips.toFixed(2) : '0.00'}}€
            </h6>
          </div>

          <div
            v-if="isAtLeastOneRestaurantPublishesReceipt && waiterOfcurrentUser && waiterOfcurrentUser.ableToSeeReceiptsWithPayments"
            class="receipts-results-container"
          >
            <h6 class="amount-of-closed">
              <font-awesome-icon style="color: #003340; margin-right:6px" icon="receipt" />Αποδείξεις
            </h6>
            <h6
              class="total-price-of-closed"
            >Σύνολο: {{getTotalPriceForReceiptsFixed(adminWithSales.prices)}}€ | ΦΠΑ: {{adminWithSales.prices !=null && adminWithSales.prices.amountOfVat!=null ? adminWithSales.prices.amountOfVat.toFixed(2) : '0.00'}}€</h6>
            <h6 class="payment-method-price">
              <font-awesome-icon style="color: #198b4a" icon="money-bill" />
              Μετρητά: {{adminWithSales.prices !=null && adminWithSales.prices.amountOfCashReceipts!=null ? adminWithSales.prices.amountOfCashReceipts.toFixed(2) : '0.00'}}€
            </h6>
            <h6 class="payment-method-price">
              <font-awesome-icon style="color: #17a2b8" icon="credit-card" />
              Κάρτα: {{adminWithSales.prices !=null && adminWithSales.prices.amountOfCardReceipts!=null ? adminWithSales.prices.amountOfCardReceipts.toFixed(2) : '0.00'}}€
            </h6>
            <h6 class="payment-method-price">
              <font-awesome-icon style="color: #efb400" icon="history" />
              Επί πιστώσει: {{adminWithSales.prices !=null && adminWithSales.prices.amountOfOnCreditReceipts!=null ? adminWithSales.prices.amountOfOnCreditReceipts.toFixed(2) : '0.00'}}€
            </h6>
            <h6 class="payment-method-price">
              <font-awesome-icon style="color: #6f2c91" icon="gift" />
              Αυτοπαραδόσεις: {{adminWithSales.prices !=null && adminWithSales.prices.amountOfSelfDeliveryReceipts!=null ? adminWithSales.prices.amountOfSelfDeliveryReceipts.toFixed(2) : '0.00'}}€
            </h6>
          </div>
        </div>
      </div>

      <div v-if="typeOfReport=='STATS' && !searching">
        <h6 class="info-message" style="padding-left:10px" v-if="itemStats.length == 0">
          <font-awesome-icon style="color: #003340; margin-right:4px" icon="info-circle" />Δεv υπάρχουν στατιστικά πωλήσεων για τα κριτήρια που έχετε επιλέξει
        </h6>

        <div v-if="amountOfOrders>0" class="total-orders-results-container">
          <h6
            class="filter-title"
            style="margin-bottom: 6px !important; font-size:16px"
          >{{amountOfOrders}} {{amountOfOrders==1 ? 'παραγγελία': 'παραγγελίες'}}</h6>
        </div>

        <div v-if="itemStats.length>0" class="selected-categories-outer-container">
          <div class="selected-categories-inner-container" style="margin-right:10px">
            <h6
              class="filter-title"
              style="margin-bottom: 4px !important; font-size:16px"
            >Επιλέξτε κατηγορία</h6>

            <div>
              <div class="category-to-select">
                <input
                  type="checkbox"
                  value="0"
                  id="cat-0"
                  style="margin-right: 5px;"
                  v-model="selectedCategories"
                  @change="toggleAllCategories"
                />
                <label for="cat-0">Όλες</label>
              </div>

              <div v-if="showMoreCategories">
                <div
                  class="category-to-select"
                  v-for="category in uniqueCategories"
                  :key="category.id"
                >
                  <input
                    type="checkbox"
                    :id="'cat-' + category.id"
                    style="margin-right: 5px"
                    :value="category.id"
                    v-model="selectedCategories"
                    @change="uncheckAllIfNeeded"
                  />
                  <label :for="'cat-' + category.id">{{getCategoryName(category)}}</label>
                </div>
              </div>

              <div
                class="show-more-btn"
                @click="onToggleShowCategories()"
              >{{ showMoreCategories ? "Δες λιγότερα" : "Κλικ εδώ για περισσότερες κατηγορίες" }}</div>
            </div>
          </div>
        </div>

        <div v-if="itemStats.length>0" class="stats-headers" style="margin-bottom: 4px !important">
          <h6
            class="filter-title"
            style="margin-bottom: 2px !important"
          >Τεμάχια: {{totalQuantityOfPcs}}</h6>
          <h6
            class="filter-title"
            style="margin-bottom: 4px !important"
          >Σύνολο: {{totalPriceOfPcs.toFixed(2)}}€</h6>
        </div>

        <table v-if="itemStats.length>0" id="statistics-results-container">
          <tr>
            <th class="product-header">Προϊόν</th>
            <th class="text-center">Τμχ</th>
            <th class="text-center">Αξία</th>
            <th class="text-center">Κατηγορία</th>
          </tr>
          <ProductStat
            :key="item.productId"
            v-for="item in itemsToShow"
            :item="item"
            :selectedDepartmentId="selectedDepartmentId"
            :typeOfSales="typeOfSales"
            :startingDate="startingDate"
            :endingDate="endingDate"
            :orderOrigin="orderOrigin"
            :waiterToSearch="waiterToSearch"
            :selectedTableId="selectedTableId"
          ></ProductStat>
        </table>
      </div>

      <div v-if="typeOfReport=='CLOSED_TABLES' && !searching" id="closed-tables-section">
        <h6 class="info-message" style="padding-left:10px" v-if="closedTableOpenings.length == 0">
          <font-awesome-icon style="color: #003340; margin-right:4px" icon="info-circle" />Δεv υπάρχουν κλειστά τραπέζια για τα κριτήρια που έχετε επιλέξει
        </h6>

        <clip-loader
          v-if="fetchingClosedTables"
          :loading="fetchingClosedTables"
          size="30px"
          color="#003340"
        />

        <table
          v-if="closedTableOpenings.length>0 && !fetchingClosedTables"
          id="closed-tables-results-container"
        >
          <tr>
            <th
              colspan="2"
              class="product-header"
              style="font-size: 16px"
            >Σύνολο: {{this.totalAmountOfClosed}} κλειστά</th>
          </tr>
          <tr>
            <th class="product-header">Λεπτομέρειες</th>
            <th class="text-center">Αξία</th>
          </tr>
          <tr
            @click="selectClosedTable(tableOpening)"
            :key="tableOpening.id"
            v-for="tableOpening in closedTableOpenings"
          >
            <td>
              <div style="display: flex; flex-direction: column">
                <span
                  class="mb-0"
                  style="font-weight: 600"
                  v-if="restaurantsWithTableOpenings.length > 1"
                >{{ tableOpening.restaurant.names.translation.GRE.name}} {{tableOpening.restaurant.alias}}</span>
                <span
                  class="mb-0"
                  style="font-weight: 600"
                >{{getThesisName(tableOpening.table.type)}} {{ tableOpening.table.tableNumber}}</span>
                <span
                  class="mb-0"
                  style="font-weight: 600"
                  v-if="tableOpening.nameOfUser!=null && tableOpening.nameOfUser.trim().length!=0"
                >
                  <font-awesome-icon
                    class="mr-1 text-primary"
                    style="margin-left: 3px"
                    icon="user"
                  />
                  {{tableOpening.nameOfUser}}
                </span>
                <div
                  v-if="tableOpening.closingDate!=null && tableOpening.closingDate.trim().length>0"
                  style="display: flex; align-items: center"
                >
                  <font-awesome-icon class="mr-1 text-dark" icon="door-closed" />
                  <span>{{tableOpening.closingDate.slice(0, -3)}}</span>
                </div>
                <div style="display: flex; align-items: center">
                  <font-awesome-icon class="mr-1 text-success" icon="door-open" />
                  <span>{{tableOpening.openingDate.slice(0, -3)}}</span>
                </div>
                <div
                  style="display: flex; align-items: center"
                  v-if="tableOpening.note!=null && tableOpening.note.trim().length>0"
                >
                  <font-awesome-icon
                    style="margin-right:6px; color: #c5097d; margin-left: 2px"
                    icon="sticky-note"
                  />
                  <span>{{tableOpening.note.slice(0,12)}}{{tableOpening.note.slice(0,12).length < tableOpening.note.length ? '..' : ''}}</span>
                </div>
                <div
                  style="display: flex; margin-left:2px; color: #636363; font-size: 13px"
                >{{'id: ' + tableOpening.id}}</div>
              </div>
            </td>

            <td>
              <div
                style="font-weight: 600 !important; display: flex"
              >Σύνολο: {{ (tableOpening.totalPrice + tableOpening.amountTreated).toFixed(2) }}€</div>
              <div
                v-if="tableOpening.amountTreated>0"
                style="font-weight: 600 !important; display: flex"
              >Εισπράχτηκαν: {{ tableOpening.totalPrice.toFixed(2) }}€</div>
              <div style="display: flex">
                <font-awesome-icon
                  style="margin-right:6px;"
                  class="text-success mt-1"
                  icon="money-bill"
                />
                {{ tableOpening.amountPayedByCash.toFixed(2) }}€
                <span
                  class="font-italic"
                  style="margin-left:6px;"
                >(Μετρητά)</span>
              </div>
              <div style="display: flex">
                <font-awesome-icon
                  style="margin-right:6px;"
                  class="text-info mt-1"
                  icon="credit-card"
                />
                {{ tableOpening.amountPayedByCard.toFixed(2) }}€
                <span
                  class="font-italic"
                  style="margin-left:6px;"
                >(Κάρτα/Bank)</span>
              </div>

              <div v-if="tableOpening.amountOnCredit>0" style="display: flex">
                <font-awesome-icon
                  style="margin-right:10px;"
                  class="mt-1 text-warning"
                  icon="history"
                />
                {{ tableOpening.amountOnCredit.toFixed(2) }}€
                <span
                  class="font-italic"
                  style="margin-left:6px;"
                >(Επί πιστώσει)</span>
              </div>

              <div
                style="display: flex"
                v-if="store && store.hotel && tableOpening.table.type!='HOTEL_ROOM'"
              >
                <font-awesome-icon
                  style="color: #003340; margin-right:6px;"
                  class="mt-1"
                  icon="bed"
                ></font-awesome-icon>
                {{ tableOpening.amountChargedToRoom.toFixed(2) }}€
                <span
                  class="font-italic"
                  style="margin-left:6px;"
                >(Room Charge)</span>
              </div>
              <div v-if="tableOpening.amountOfDiscounts>0" style="display: flex">
                <font-awesome-icon
                  style="margin-right:10px;"
                  class="mt-1 text-success"
                  icon="percent"
                />
                {{ tableOpening.amountOfDiscounts.toFixed(2) }}€
                <span
                  class="font-italic"
                  style="margin-left:6px;"
                >(Έκπτωση)</span>
              </div>
              <div v-if="tableOpening.amountTreated>0" style="display: flex">
                <font-awesome-icon
                  style="margin-right:10px; color: #6f2c91;"
                  class="mt-1"
                  icon="gift"
                />
                {{ tableOpening.amountTreated.toFixed(2) }}€
                <span
                  class="font-italic"
                  style="margin-left:6px;"
                >(Κεράστηκαν)</span>
              </div>
              <div v-if="tableOpening.amountCanceled>0" style="display: flex">
                <font-awesome-icon
                  style="margin-right:10px; margin-left:2px; color: #d9534f;"
                  class="mt-1"
                  icon="trash"
                />
                {{ tableOpening.amountCanceled.toFixed(2) }}€
                <span
                  class="font-italic"
                  style="margin-left:6px;"
                >(Ακυρώθηκαν)</span>
              </div>
              <div
                v-if="(tableOpening.amountOfCashReceipts + tableOpening.amountOfCardReceipts + tableOpening.amountOfOnCreditReceipts + tableOpening.amountOfSelfDeliveryReceipts)>0"
                style="display: flex"
              >
                <font-awesome-icon
                  style="margin-right:8px; margin-left:2px;"
                  class="mt-1 text-dark"
                  icon="cash-register"
                />
                {{ (tableOpening.amountOfCashReceipts + tableOpening.amountOfCardReceipts + tableOpening.amountOfOnCreditReceipts + tableOpening.amountOfSelfDeliveryReceipts).toFixed(2) }}€
                <span
                  class="font-italic"
                  style="margin-left:6px;"
                >(Αποδείξεις)</span>
              </div>
            </td>
          </tr>
        </table>

        <paginate
          v-if="!searching && pageCount>1"
          :pageCount="pageCount"
          :page-range="3"
          :containerClass="'pagination'"
          :clickHandler="changePage"
        ></paginate>
      </div>

      <clip-loader v-if="searching" :loading="searching" size="30px" color="#003340" />
    </div>
    <div
      id="general-errors-container"
      v-if="(!isLoggedIn || waiterOfcurrentUser==null || !waiterOfcurrentUser.ableToSeeMobileReports) && !isLoading"
    >
      <h6 class="info-message" v-if="!isLoggedIn">
        <font-awesome-icon style="color: #003340; margin-right:4px" icon="info-circle" />Για να δείτε τα έσοδα πρέπει να συνδεθείτε. Πηγαίντε πίσω και κάντε είσοδο πάνω δεξιά με το pin σας. Ξαναμπείτε μετά εδώ ώστε να δείτε τα έσοδα του καταστήματος
      </h6>
      <h6
        class="info-message"
        v-if="isLoggedIn && (waiterOfcurrentUser==null || !waiterOfcurrentUser.ableToSeeMobileReports)"
      >
        <font-awesome-icon style="color: #003340; margin-right:4px" icon="info-circle" />Δεν έχετε δικαιώματα προβολής εσόδων του καταστήματος
      </h6>
    </div>
    <div
      @click="onMaskClick"
      :class="{
        mask:
          isEntranceOpen ||
          isLanguageModalOpen
      }"
    ></div>
    <PoweredByFooter v-if="!isLoading"></PoweredByFooter>
    <OrdersOfOpenTableModal
      ref="ordersOfOpenTableComponent"
      v-bind:class="{ hide: !isTableOrdersModalOpen}"
      :isFromHistoryScreen="true"
      :tableOpening="selectedTableOpening"
      :loadingOrders="loadingOrders"
      :ordersOfSelectedTableOpening="ordersOfSelectedTableOpening"
      :tempReceiptsOfSelectedTableOpening="tempReceiptsOfSelectedTableOpening"
      :ordersConcatedNote="ordersConcatedNote"
      :errorWhileLoadingOrders="errorWhileLoadingOrders"
      :hotelRooms="hotelRooms"
      :isHotel="store && store.hotel"
      :assignedTablesOnly="store && store.assignedTablesOnly"
      :waiterIds="waiterIds"
      :waiters="waitersToShow"
      @update-selected-tableOpening="updateSelectedTableOpening"
      @remove-selected-tableOpening-from-list="removeSelectedTableOpening"
      :authToken="authToken"
      :sections="[]"
      :jwt="jwt"
      :currentUserId="currentUserId"
      :waiterOfcurrentUser="waiterOfcurrentUser"
      :tablesUserIsAbleToTransfer="[]"
      :adminAccounts="adminAccounts"
    ></OrdersOfOpenTableModal>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import Store from "../Store";
import StoreApi from "../../api/stores";
import UserApi from "../../api/user";
import OrderApi from "../../api/order";
import ProfileDropdown from "../ProfileDropdown";
import EnterPrompt from "../EnterPrompt";
import LanguageSelect from "../LanguageSelect";
import BackToServices from "../BackToServices.vue";
import ProductStat from "../ProductStat.vue";
import OrdersOfOpenTableModal from "../OrdersOfOpenTableModal";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import Paginate from 'vuejs-paginate'

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import _ from "lodash";

import PoweredByFooter from "../PoweredByFooter.vue";

export default {
  name: "TablesScreen",
  components: {
    Store,
    ProfileDropdown,
    EnterPrompt,
    Loading,
    LanguageSelect,
    BackToServices,
    ProductStat,
    ClipLoader,
    OrdersOfOpenTableModal,
    PoweredByFooter,
    DatePicker,
    Paginate
  },
  props: [""],
  data() {
    return {
      store: undefined,
      isLoading: true,
      from: undefined,
      fromRouteName: '',
      shouldShowEnterPrompt: false,
      isApplication: false,
      isAbleToChangeLanguage: true,
      tableType: "ALL",
      selectedDepartmentId: null,
      selectedTableId: null,
      hotelRooms: [],
      tables: [],
      tablesToShowForSelection: [],
      waiters: [],
      waiterIds: [],
      tableSections: [],
      selectedSection: null,
      waiterOfcurrentUser: null,
      startingDate: null,
      endingDate: null,
      lastSearchStartingDate: null,
      lastSearchEndingDate: null,
      pricesOfClosed: null,
      totalAmountOfClosed: 0,
      isAtLeastOneRestaurantPublishesReceipt: false,
      error: false,
      errorMessage: '',
      waiterToSearch: null,
      lastWaiterToSearch: null,
      searching: true,
      typeOfReport: "ACCOUNTS",
      itemStats: [],
      amountOfOrders: 0,
      selectedCategories: ['0'],
      showMoreCategories: false,
      adminsWithSales: [],
      printingUserSales: null,
      typeOfSales: "ALL_WITHOUT_CANCELED",
      resultsPerPage: 35,
      pageCount: 0,
      closedTableOpenings: [],
      fetchingClosedTables: false,
      selectedTableOpening: null,
      loadingOrders: false,
      ordersOfSelectedTableOpening: [],
      tempReceiptsOfSelectedTableOpening: [],
      ordersConcatedNote: "",
      errorWhileLoadingOrders: false,
      orderOrigin: null
    };
  },
  watch: {
    isTableOrdersModalOpen: function (newVal, oldVal) {
      let htmlElement = document.querySelector("html");
      if (newVal == true) {
        htmlElement.style.overflow = "hidden";
      } else {
        htmlElement.style.overflow = "auto";
      }
    }
  },
  async mounted() {
    this.isLoading = true;

    let storeId = this.$router.currentRoute.params.storeId;
    let tableId = this.$router.currentRoute.params.tableId;
    this.selectToday(storeId);
    if (this.$route.params.store) {
      this.store = this.$route.params.store;
    } else if (!this.store) {
      this.store = await StoreApi.getStoreById(storeId);
    }
    this.$store.dispatch("setTableId", tableId)

    let serviceName = {
      GRE: {
        name: "Έσοδα"
      },
      ENG: {
        name: "Earnings"
      },
    };
    this.$store.dispatch("setServiceName", serviceName);
    this.setTitle();

    this.isLoading = false;
    if (this.isLoggedIn) {
      await this.loadRequiredStuffForFilters();
      if (this.waiterOfcurrentUser != null && this.waiterOfcurrentUser.ableToSeeMobileReports) {
        this.searching = true;
        if (this.waiterOfcurrentUser.orderHistoryScope == 'PERSONAL_TODAY') {
          this.waiterToSearch = this.waiterOfcurrentUser.userId;
        }
        await this.getReports();
        await this.getAdminAccountsOfUser();
      }

      let availableTables = this.tables.concat(this.hotelRooms);
      this.tablesToShowForSelection = availableTables;
    }

  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fromRouteName = from.name;
      vm.from = from;
    });
  },
  beforeRouteLeave(to, from, next) {
    if (this.isEntranceOpen) {
      this.closeEntrance();
      //below is needed for same reason as above
      window.history.scrollRestoration = "manual";
      next(false);
    } else if (this.isLanguageModalOpen) {
      this.$store.dispatch("closeLanguageModal");
      //below is needed as if route is the same as before after next(false)
      //browser autoscrolls to top of page
      window.history.scrollRestoration = "manual";
      next(false);
    } else if (this.isTableOrdersModalOpen) {
      try {
        this.$refs.ordersOfOpenTableComponent.setResetOfStateOnOrdersChange(true);
      } catch (error) {
        console.log("Could not stop reset of state on orders change");
      }
      this.$store.dispatch("closeTableOrdersModal");
      //below is needed as if route is the same as before after next(false)
      //browser autoscrolls to top of page
      window.history.scrollRestoration = "manual";
      next(false);
    } else {
      next();
    }
  },
  beforeDestroy() {

  },
  computed: {
    tableId() {
      return this.$store.getters.getTableId;
    },

    isEntranceOpen() {
      return this.$store.getters.getSlideEntranceIn;
    },

    isTableOrdersModalOpen() {
      return this.$store.state.tableOrdersModalOpen;
    },

    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },

    isLanguageModalOpen() {
      return this.$store.getters.isLanguageModalOpen;
    },

    language() {
      return this.$store.getters.getLanguage;
    },

    currentGreekDate() {
      return this.$store.getters.getCurrentGreekDate;
    },

    authToken() {
      return this.$store.getters.getUserAuthToken;
    },

    jwt() {
      return this.$store.getters.getUserJWT;
    },

    restaurantsWithTableOpenings() {
      return this.$store.getters.getRestaurantsWithTableOpenings;
    },

    adminAccounts() {
      return this.$store.getters.getAdminAccounts;
    },

    currentUserId() {
      return this.$store.getters.getUserId;
    },

    storeName() {
      if (this.store) {
        return this.store.names && this.store.names.translation[this.language]
          ? this.store.names.translation[this.language].name
          : this.store.name;
      }
    },

    title() {
      return `Store history | Fluter`;
    },

    uniqueCategories() {
      if (this.itemStats == null || this.itemStats.length == 0) {
        return;
      } else {
        let uniqueCategories = [];

        this.itemStats.forEach((item) => {
          uniqueCategories.push(item.productCategory);
        });

        const unique = [
          ...new Map(
            uniqueCategories.map((item) => [item["id"], item])
          ).values(),
        ];

        return unique;
      }
    },

    itemsToShow() {

      if (this.itemStats == null || this.itemStats.length == 0) {
        return [];
      }

      if (this.selectedCategories.length <= 1 && (this.selectedCategories.includes("0") || this.selectedCategories.includes(0))) {
        return this.itemStats;
      };

      return this.itemStats.filter(itemStat => this.selectedCategories.includes(itemStat.productCategory.id));

    },

    totalQuantityOfPcs() {
      let totalQuantity = 0;
      for (let item of this.itemsToShow) {
        totalQuantity = totalQuantity + item.quantity;
      }
      return totalQuantity;
    },

    totalPriceOfPcs() {
      let totalPrice = 0;
      for (let item of this.itemsToShow) {
        totalPrice = totalPrice + item.totalPrice;
      }
      return totalPrice;
    },

    timePickerOptions() {
      return {
        start: '00:00',
        step: `00:15`,
        end: '23:59',
        format: 'HH:mm'
      };
    },

    waitersToShow() {
      if (this.waiterOfcurrentUser != null && this.waiterOfcurrentUser.userId == 166) {
        return this.waiters;
      }
      return this.waiters.filter(waiter => waiter.userId != 166);
    },

    tablesToSearch() {
      let tablesToSearch = [];
      if (this.tableType == 'ALL') {
        tablesToSearch = this.tables.concat(this.hotelRooms);
      } else if (this.tableType == 'TABLES') {
        tablesToSearch = this.tables.filter(table => table.type == 'TABLE' || table.type == 'BEACH_CHAIR' || table.type == 'TABLE_AT_HOTEL' || table.type == 'UMBRELLA_AT_HOTEL');
      } else if (this.tableType == 'ROOMS') {
        tablesToSearch = this.hotelRooms;
      } else if (this.tableType == 'DELIVERY') {
        tablesToSearch = this.tables.filter(table => table.type == 'DELIVERY' || table.serviceMode == 'DELIVERY');
      } else {
        tablesToSearch = this.tables.filter(table => table.type == 'QR_SELF_SERVICE' || table.type == 'SELF_SERVICE_POS' || table.serviceMode == 'TAKEAWAY');
      }

      if (this.selectedSection != null) {
        tablesToSearch = tablesToSearch.filter(table => table.familySection == this.selectedSection);
      }

      return tablesToSearch;
    },

  },

  methods: {

    async changePage(page) {
      this.fetchingClosedTables = true;

      let restaurantIds = this.selectedDepartmentId == null ? this.restaurantsWithTableOpenings.map(restaurant => restaurant.id) : this.selectedDepartmentId;

      let tableIds = [];
      if (this.selectedTableId == null) {
        let availableTables = this.tablesToSearch;
        tableIds = availableTables.map(table => table.id);
      } else {
        tableIds.push(this.selectedTableId);
      }

      let userIds = [];
      if (this.waiterToSearch != null) {
        userIds.push(this.waiterToSearch);
      }

      let startingDateForServer = this.formatDateForServer(this.startingDate);
      let endingDateForServer = this.formatDateForServer(this.endingDate);

      let pageToSearch = page - 1;
      this.closedTableOpenings = await StoreApi.getClosedTableOpenings(restaurantIds, tableIds, userIds, startingDateForServer, endingDateForServer, pageToSearch, this.resultsPerPage, this.authToken, this.jwt)
      this.fetchingClosedTables = false;
    },

    toggleAllCategories() {
      // If "All" is checked, remove all others
      if (this.selectedCategories.includes('0')) {
        this.selectedCategories = ['0'];
      }
    },

    onToggleShowCategories() {
      this.showMoreCategories = !this.showMoreCategories;
    },

    uncheckAllIfNeeded() {
      // If user selects any category, remove "All"
      const index = this.selectedCategories.indexOf('0');
      if (index !== -1 && this.selectedCategories.length > 1) {
        this.selectedCategories.splice(index, 1);
      }
    },

    async adaptTables() {
      this.selectedTableId = null;
      if (this.tableType == 'ALL') {
        if (this.selectedDepartmentId == null) {
          let availableTables = this.tables.concat(this.hotelRooms);
          this.tablesToShowForSelection = availableTables;
        } else {
          let restaurantIds = [];
          restaurantIds.push(this.selectedDepartmentId);
          this.searching = true;
          let restaurantsWithTables = await StoreApi.fetchAllSpotsForRestaurants(this.store.id, restaurantIds);
          this.searching = false;
          let availableTables = restaurantsWithTables[0].tables.concat(this.hotelRooms);
          this.tablesToShowForSelection = availableTables;
        }
      }

      if (this.tableType == 'ROOMS') {
        this.tablesToShowForSelection = this.hotelRooms;
      }

      if (this.tableType == 'DELIVERY') {
        if (this.selectedDepartmentId == null) {
          let availableTables = this.tables;
          this.tablesToShowForSelection = availableTables.filter(table => table.type == 'DELIVERY' || table.type == 'DELIVERY_TABLE' || table.serviceMode == 'DELIVERY');
        } else {

          let restaurantIds = [];
          restaurantIds.push(this.selectedDepartmentId);
          this.searching = true;
          let restaurantsWithTables = await StoreApi.fetchAllSpotsForRestaurants(this.store.id, restaurantIds);
          this.searching = false;
          this.tablesToShowForSelection = restaurantsWithTables[0].tables.filter(table => table.type == 'DELIVERY' || table.type == 'DELIVERY_TABLE' || table.serviceMode == 'DELIVERY');
        }
      }

      if (this.tableType == 'TAKE_AWAY') {
        if (this.selectedDepartmentId == null) {
          let availableTables = this.tables;
          this.tablesToShowForSelection = availableTables.filter(table => table.type == 'QR_SELF_SERVICE' || table.type == 'SELF_SERVICE_POS' || table.serviceMode == 'TAKEAWAY');
        } else {

          let restaurantIds = [];
          restaurantIds.push(this.selectedDepartmentId);
          this.searching = true;
          let restaurantsWithTables = await StoreApi.fetchAllSpotsForRestaurants(this.store.id, restaurantIds);
          this.searching = false;
          this.tablesToShowForSelection = restaurantsWithTables[0].tables.filter(table => table.type == 'QR_SELF_SERVICE' || table.type == 'SELF_SERVICE_POS' || table.serviceMode == 'TAKEAWAY');
        }

      }

      if (this.tableType == 'TABLES') {
        if (this.selectedDepartmentId == null) {
          let availableTables = this.tables;
          this.tablesToShowForSelection = availableTables.filter(table => table.type == 'TABLE' || table.type == 'BEACH_CHAIR' || table.type == 'TABLE_AT_HOTEL' || table.type == 'UMBRELLA_AT_HOTEL');
        } else {
          let restaurantIds = [];
          restaurantIds.push(this.selectedDepartmentId);
          this.searching = true;
          let restaurantsWithTables = await StoreApi.fetchAllSpotsForRestaurants(this.store.id, restaurantIds);
          this.searching = false;
          this.tablesToShowForSelection = restaurantsWithTables[0].tables.filter(table => table.type == 'TABLE' || table.type == 'BEACH_CHAIR' || table.type == 'TABLE_AT_HOTEL' || table.type == 'UMBRELLA_AT_HOTEL');
        }
      }

      this.tableSections = [];
      this.tablesToShowForSelection.forEach(tableToShow => {
        if (!this.tableSections.includes(tableToShow.familySection) && tableToShow.familySection != null && tableToShow.familySection.trim().length > 0) {
          this.tableSections.push(tableToShow.familySection);
        }
      })

      if (this.selectedSection != null && !this.tableSections.includes(this.selectedSection)) {
        this.selectedSection = null;
      }

      if (this.selectedSection != null) {
        this.tablesToShowForSelection = this.tablesToShowForSelection.filter(table => table.familySection == this.selectedSection);
      }

    },


    getThesisName(thesisType) {

      let thesisName = "";
      switch (thesisType) {
        case "HOTEL_ROOM":
          thesisName = "Δωμάτιο:";
          break;
        case "TABLE":
          thesisName = "Τραπέζι:";
          break;
        case "TABLE_AT_HOTEL":
          thesisName = "Τραπέζι:";
          break;
        case "BEACH_CHAIR":
          thesisName = "Ομπρέλα:";
          break;
        case "UMBRELLA_AT_HOTEL":
          thesisName = "Ομπρέλα:";
          break;
        default:
          thesisName = "Θέση:";
      }
      return thesisName;
    },

    async selectClosedTable(tableOpening) {
      this.ordersConcatedNote = "";
      this.ordersOfSelectedTableOpening = [];
      this.tempReceiptsOfSelectedTableOpening = [];
      this.selectedTableOpening = tableOpening;
      this.loadingOrders = true;
      this.errorWhileLoadingOrders = false;
      this.$store.dispatch("openTableOrdersModal");

      let apiResponses = await Promise.all([OrderApi.getOrdersByTableOpening(tableOpening.id, tableOpening.restaurant.id, this.authToken, this.jwt), StoreApi.fetchTempReceiptsForTableOpening(tableOpening.id, tableOpening.restaurant.id, this.authToken, this.jwt)]).then(data => data);
      if (apiResponses[0].error || apiResponses[1].error) {
        this.errorWhileLoadingOrders = true;
      } else {
        let commentOfAllOrders = "";
        apiResponses[0].forEach(order => {
          if (order.comment != null && order.comment.trim().length > 0)
            if (commentOfAllOrders == "") {
              commentOfAllOrders = commentOfAllOrders + order.comment;
            } else {
              commentOfAllOrders = commentOfAllOrders + ", " + order.comment;
            }
        });
        this.ordersConcatedNote = commentOfAllOrders;
        this.ordersOfSelectedTableOpening = apiResponses[0];
        this.tempReceiptsOfSelectedTableOpening = apiResponses[1];
      }
      this.loadingOrders = false;
    },

    async updateSelectedTableOpening(tableOpening) {
      const index = this.closedTableOpenings.findIndex(opening => opening.id === tableOpening.id);
      if (index != -1) {
        this.closedTableOpenings.splice(index, 1, tableOpening);
      }
      await this.selectClosedTable(tableOpening);
    },

    removeSelectedTableOpening(tableOpening) {
      this.closedTableOpenings = this.closedTableOpenings.filter(opening => opening.id != tableOpening.id);
    },

    getWaiterNameWithDeactivatedStatus(userId) {
      let user = this.waiters.find(waiter => waiter.userId == userId);
      if (user) {
        let name = user.deactivated ? user.name + ' (Ανενεργός)' : user.name;
        return name;
      }
      return "";
    },

    getWaiterName(userId) {
      let user = this.waiters.find(waiter => waiter.userId == userId);
      if (user) {
        return user.name;
      }
      return "";
    },

    getCategoryName(category) {
      return category.categoryName.translation.GRE
        ? category.categoryName.translation.GRE.name
        : category.categoryName.translation.ENG
          ? category.categoryName.translation.ENG.name
          : "";
    },

    getProductName(item) {
      return item.productName.translation.GRE
        ? item.productName.translation.GRE.name
        : item.productName.translation.ENG
          ? item.productName.translation.ENG.name
          : "";
    },

    getProductCategoryName(item) {
      return item.productCategory.categoryName.translation.GRE
        ? item.productCategory.categoryName.translation.GRE.name
        : item.productCategory.categoryName.translation.ENG
          ? item.productCategory.categoryName.translation.ENG.name
          : "";
    },

    getTotalPriceFixed(pricesOfClosed) {
      let amountOfCash = pricesOfClosed != null && pricesOfClosed.amountPayedByCash != null ? pricesOfClosed.amountPayedByCash : 0;
      let amountOfCard = pricesOfClosed != null && pricesOfClosed.amountPayedByCard != null ? pricesOfClosed.amountPayedByCard : 0;
      let amountOfOnCredit = pricesOfClosed != null && pricesOfClosed.amountOnCredit != null ? pricesOfClosed.amountOnCredit : 0;
      let amountOfRoomCharges = pricesOfClosed != null && pricesOfClosed.amountChargedToRoom != null ? pricesOfClosed.amountChargedToRoom : 0;

      return (amountOfCard + amountOfCash + amountOfOnCredit + amountOfRoomCharges).toFixed(2);
    },

    getTotalPriceNotFixed(pricesOfClosed) {
      let amountOfCash = pricesOfClosed != null && pricesOfClosed.amountPayedByCash != null ? pricesOfClosed.amountPayedByCash : 0;
      let amountOfCard = pricesOfClosed != null && pricesOfClosed.amountPayedByCard != null ? pricesOfClosed.amountPayedByCard : 0;
      let amountOfOnCredit = pricesOfClosed != null && pricesOfClosed.amountOnCredit != null ? pricesOfClosed.amountOnCredit : 0;
      let amountOfRoomCharges = pricesOfClosed != null && pricesOfClosed.amountChargedToRoom != null ? pricesOfClosed.amountChargedToRoom : 0;

      return (amountOfCard + amountOfCash + amountOfOnCredit + amountOfRoomCharges);
    },

    getTotalPriceForReceiptsFixed(pricesOfClosed) {
      let amountOfCashReceipts = pricesOfClosed != null && pricesOfClosed.amountOfCashReceipts != null ? pricesOfClosed.amountOfCashReceipts : 0;
      let amountOfCardReceipts = pricesOfClosed != null && pricesOfClosed.amountOfCardReceipts != null ? pricesOfClosed.amountOfCardReceipts : 0;
      let amountOfOnCreditReceipts = pricesOfClosed != null && pricesOfClosed.amountOfOnCreditReceipts != null ? pricesOfClosed.amountOfOnCreditReceipts : 0;
      let amountOfSelfDeliveryReceipts = pricesOfClosed != null && pricesOfClosed.amountOfSelfDeliveryReceipts != null ? pricesOfClosed.amountOfSelfDeliveryReceipts : 0;

      return (amountOfCardReceipts + amountOfCashReceipts + amountOfOnCreditReceipts + amountOfSelfDeliveryReceipts).toFixed(2);
    },

    getTotalPriceForReceiptsNotFixed(pricesOfClosed) {
      let amountOfCashReceipts = pricesOfClosed != null && pricesOfClosed.amountOfCashReceipts != null ? pricesOfClosed.amountOfCashReceipts : 0;
      let amountOfCardReceipts = pricesOfClosed != null && pricesOfClosed.amountOfCardReceipts != null ? pricesOfClosed.amountOfCardReceipts : 0;
      let amountOfOnCreditReceipts = pricesOfClosed != null && pricesOfClosed.amountOfOnCreditReceipts != null ? pricesOfClosed.amountOfOnCreditReceipts : 0;
      let amountOfSelfDeliveryReceipts = pricesOfClosed != null && pricesOfClosed.amountOfSelfDeliveryReceipts != null ? pricesOfClosed.amountOfSelfDeliveryReceipts : 0;

      return (amountOfCardReceipts + amountOfCashReceipts + amountOfOnCreditReceipts + amountOfSelfDeliveryReceipts);
    },


    onMaskClick: function () {
      if (this.isEntranceOpen) {
        this.closeEntrance();
      } else if (this.isLanguageModalOpen) {
        this.$store.dispatch("closeLanguageModal");
      }
    },

    clearErrors() {
      this.error = false;
      this.errorMessage = '';
    },

    closeEntrance: function () {
      this.$store.dispatch("shouldSlideEntranceOut");

      this.$store.dispatch("shouldNotSlideEntranceIn");

      setTimeout(() => {
        this.$store.dispatch("resetEntranceState");
        this.$store.dispatch("setEntranceMessage", "");

        this.$store.dispatch("resetVerificationState");
        this.$store.dispatch("setVerificationMessage", "");
      }, 850);
    },

    initiateEntrance: function () {
      this.$store.dispatch("shouldSlideEntranceIn");
    },

    formatDateForServer(date) {
      let yyyy = date.getFullYear();
      let MM = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      let dd = String(date.getDate()).padStart(2, '0');
      let HH = String(date.getHours()).padStart(2, '0');
      let mm = String(date.getMinutes()).padStart(2, '0');
      let ss = String(date.getSeconds()).padStart(2, '0');

      return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`;
    },

    async setTypeOfReport(typeOfReport) {


      if (typeOfReport == this.typeOfReport) {
        return;
      }

      if (this.typeOfReport != 'STATS' && typeOfReport == 'STATS') {
        this.orderOrigin = null;
        this.typeOfSales = 'ALL_WITHOUT_CANCELED';
      }

      this.typeOfReport = typeOfReport;

      if (typeOfReport == 'STATS' && this.selectedDepartmentId == null) {
        this.selectedDepartmentId = this.restaurantsWithTableOpenings[0].id;
        this.tableType = 'ALL';
        this.selectedSection = null;
        this.adaptTables();
      } else if (typeOfReport == 'ACCOUNTS' || typeOfReport == 'ACTIONS' || typeOfReport == 'CLOSED_TABLES') {
        this.selectedDepartmentId = null;
      }

      if (this.typeOfReport == 'ACCOUNTS') {
        await this.getHistoryOfAccounts();
      } else if (this.typeOfReport == 'ACTIONS') {
        await this.getHistoryOfActions();
      } else if (this.typeOfReport == 'STATS') {
        this.selectedCategories = ['0'];
        this.showMoreCategories = false;
        await this.getProductSales();
      } else if (this.typeOfReport == 'CLOSED_TABLES') {
        await this.getClosedTableOpeningsWithTotalResults();
      }
    },

    async onTypeOfSalesChange() {
      this.selectedCategories = ['0'];
      this.showMoreCategories = false;
      await this.getProductSales();
    },

    async getClosedTableOpeningsWithTotalResults() {
      this.searching = true;

      let restaurantIds = this.selectedDepartmentId == null ? this.restaurantsWithTableOpenings.map(restaurant => restaurant.id) : this.selectedDepartmentId;

      let tableIds = [];
      if (this.selectedTableId == null) {
        let availableTables = this.tablesToSearch;
        tableIds = availableTables.map(table => table.id);
      } else {
        tableIds.push(this.selectedTableId);
      }

      let userIds = [];
      if (this.waiterToSearch != null) {
        userIds.push(this.waiterToSearch);
      }

      let startingDateForServer = this.formatDateForServer(this.startingDate);
      let endingDateForServer = this.formatDateForServer(this.endingDate);

      let apiResponse = await Promise.all([StoreApi.getClosedTableOpenings(restaurantIds, tableIds, userIds, startingDateForServer, endingDateForServer, 0, this.resultsPerPage, this.authToken, this.jwt), StoreApi.getTotalAmountOfClosedTables(restaurantIds, tableIds, userIds, startingDateForServer, endingDateForServer, this.authToken, this.jwt)]).then(data => {
        return {
          closedTableOpenings: data[0],
          totalAmountOfClosed: data[1]
        }
      });

      this.closedTableOpenings = apiResponse.closedTableOpenings;
      this.totalAmountOfClosed = apiResponse.totalAmountOfClosed;

      let remainder = this.totalAmountOfClosed % this.resultsPerPage;
      let quotient = Math.trunc(this.totalAmountOfClosed / this.resultsPerPage);
      this.pageCount = remainder > 0 ? quotient + 1 : quotient;

      this.searching = false;
    },

    async onDepartmentChange() {
      this.selectedSection = null;
      this.tableType = 'ALL';
      this.adaptTables();
      if (this.typeOfReport == 'ACCOUNTS') {
        await this.getHistoryOfAccounts();
      } else if (this.typeOfReport == 'ACTIONS') {
        await this.getHistoryOfActions();
      } else if (this.typeOfReport == 'STATS') {
        this.selectedCategories = ['0'];
        this.showMoreCategories = false;
        await this.getProductSales();
      } else if (this.typeOfReport == 'CLOSED_TABLES') {
        await this.getClosedTableOpeningsWithTotalResults();
      }
    },

    selectToday(storeId) {
      let now = new Date();
      let hours = now.getHours();
      let minutes = now.getMinutes();
      let month = now.getMonth() + 1;
      let date = now.getDate();

      let timeThatDateChanges = storeId == 181 || storeId == 316 ? "T10:30:00" : "T05:30:00"; //TODO fix this properly with a backend flag that will define if it is bar

      let hourToConsiderDateChange = storeId == 181 || storeId == 316 ? 10 : 5; //TODO fix this properly with a backend flag that will define if it is bar

      if (hours < hourToConsiderDateChange || (hours === hourToConsiderDateChange && minutes < 30)) {
        if (date == 1) {
          let previousMonth = month == 1 ? 12 : month - 1;
          let yearForStartingDate = previousMonth == 12 ? now.getFullYear() - 1 : now.getFullYear();
          let startingDay = this.getLastDayOfMonth(previousMonth, yearForStartingDate);
          startingDay = startingDay < 10 ? `0${startingDay}` : startingDay;
          previousMonth = previousMonth < 10 ? `0${previousMonth}` : previousMonth;
          this.startingDate = new Date(`${yearForStartingDate}-${previousMonth}-${startingDay}${timeThatDateChanges}`);

          let yearForEndingDate = now.getFullYear();
          let startingDayForEndingDate = date < 10 ? `0${date}` : date;
          let endingMonth = month < 10 ? `0${month}` : month;
          this.endingDate = new Date(`${yearForEndingDate}-${endingMonth}-${startingDayForEndingDate}${timeThatDateChanges}`);

        } else {
          let startingDay = date - 1;
          let year = now.getFullYear();
          startingDay = startingDay < 10 ? `0${startingDay}` : startingDay;
          month = month < 10 ? `0${month}` : month;
          this.startingDate = new Date(`${year}-${month}-${startingDay}${timeThatDateChanges}`);

          date = date < 10 ? `0${date}` : date;
          this.endingDate = new Date(`${year}-${month}-${date}${timeThatDateChanges}`);

        }
      } else {
        let year = now.getFullYear();
        let lastDayOfMonth = this.getLastDayOfMonth(month, year);
        if (date == lastDayOfMonth) {
          let startingDay = date;
          let year = now.getFullYear();
          startingDay = startingDay < 10 ? `0${startingDay}` : startingDay;
          let startingMonth = month < 10 ? `0${month}` : month;
          this.startingDate = new Date(`${year}-${startingMonth}-${startingDay}${timeThatDateChanges}`);

          let endingDay = '01'
          let endingMonth = month + 1 == 13 ? 1 : month + 1;
          let endingYear = endingMonth == 1 ? year + 1 : year;
          endingMonth = endingMonth < 10 ? `0${endingMonth}` : endingMonth;
          this.endingDate = new Date(`${endingYear}-${endingMonth}-${endingDay}${timeThatDateChanges}`);
        } else {
          let startingDay = date;
          let year = now.getFullYear();
          startingDay = startingDay < 10 ? `0${startingDay}` : startingDay;
          let startingMonth = month < 10 ? `0${month}` : month;
          this.startingDate = new Date(`${year}-${startingMonth}-${startingDay}${timeThatDateChanges}`);

          let endingDay = date + 1;
          endingDay = endingDay < 10 ? `0${endingDay}` : endingDay;
          let endingMonth = month < 10 ? `0${month}` : month;
          this.endingDate = new Date(`${year}-${endingMonth}-${endingDay}${timeThatDateChanges}`);
        }
      }
    },

    getLastDayOfMonth(month, year) {
      if (month == 2) {
        let lastDay = year % 4 == 0 ? 29 : 28;
        return lastDay;
      } else {
        let monthsWith30Days = [4, 6, 9, 11];
        let lastDay = monthsWith30Days.includes(month) ? 30 : 31;
        return lastDay;
      }
    },

    scrollDownPixels(pixels) {
      try {
        window.scrollTo(0, window.scrollY + pixels);
      } catch (error) {
        console.log("Could not scroll");
      }
    },

    findServiceName(userId) {
      let waiter = this.waiters.find(waiter => waiter.userId == userId);
      if (waiter != null) {
        return waiter.name;
      }
      return "-";
    },

    async loadRequiredStuffForFilters() {
      this.isLoading = true;

      let restaurantsWithTableOpenings = await StoreApi.getRestaurantsWithTableOpenings(this.store.id, this.authToken, this.jwt);
      this.$store.dispatch("setRestaurantsWithTableOpenings", restaurantsWithTableOpenings);

      let restaurantIds = restaurantsWithTableOpenings.map(restaurant => restaurant.id);

      if (this.store.hotel && this.hotelRooms.length == 0) {
        let apiResponse = await Promise.all([StoreApi.getListOfRooms(this.store.id, false, null, false), StoreApi.getAllTablesOfStore(this.store.id), StoreApi.fetchAllWaiters(restaurantIds, this.authToken, this.jwt)]).then(data => {
          return {
            rooms: data[0],
            tables: data[1],
            waiters: data[2]
          }
        });
        this.hotelRooms = apiResponse.rooms;
        this.tables = apiResponse.tables;
        this.waiters = apiResponse.waiters;
        this.waiterIds = apiResponse.waiters.filter(waiter => !waiter.deactivated).map(waiter => waiter.userId);
      } else {
        let apiResponse = await Promise.all([StoreApi.getAllTablesOfStore(this.store.id), StoreApi.fetchAllWaiters(restaurantIds, this.authToken, this.jwt)]).then(data => {
          return {
            tables: data[0],
            waiters: data[1]
          }
        });

        this.tables = apiResponse.tables;
        this.waiters = apiResponse.waiters;
        this.waiterIds = apiResponse.waiters.filter(waiter => !waiter.deactivated).map(waiter => waiter.userId);
      }

      this.tableSections = [];
      this.tables.forEach(table => {
        if (!this.tableSections.includes(table.familySection) && table.familySection != null && table.familySection.trim().length != 0) {
          this.tableSections.push(table.familySection);
        }
      });

      if (this.hotelRooms != null && this.hotelRooms.length > 0) {
        this.hotelRooms.forEach(hotelRoom => {
          if (!this.tableSections.includes(hotelRoom.familySection) && hotelRoom.familySection != null && hotelRoom.familySection.trim().length != 0) {
            this.tableSections.push(hotelRoom.familySection);
          }
        });
      };

      this.waiterOfcurrentUser = this.waiters.find(waiter => waiter.userId == this.currentUserId);
      this.isAtLeastOneRestaurantPublishesReceipt = restaurantsWithTableOpenings.some(restaurantWithOpening => restaurantWithOpening.publishesReceipts);
      this.selectedDepartmentId = null
      this.isLoading = false;

    },

    async sendAdminSalesForPrint(pricesOfClosed, userId) {

      this.$confirm({
        message: "Είστε σίγουρος για την εκτύπωση της αναφοράς εσόδων;",
        button: {
          yes: 'Ναι',
          no: 'Όχι'
        },
        callback: async confirm => {
          if (confirm) {
            if (this.waiterOfcurrentUser && this.waiterOfcurrentUser.orderHistoryScope == 'PERSONAL_TODAY') {
              userId = this.waiterOfcurrentUser.userId;
            }

            this.printingUserSales = userId;
            pricesOfClosed.userId = (userId == null || userId == 0) && this.lastWaiterToSearch != null ? this.lastWaiterToSearch : userId;

            let name = userId != null && userId != 0 ? this.getWaiterName(userId) : null;
            name = name == null && this.lastWaiterToSearch != null ? this.getWaiterName(this.lastWaiterToSearch) : name;
            pricesOfClosed.name = name;

            let startingDateForServer = this.formatDateForServer(this.lastSearchStartingDate);
            let endingDateForServer = this.formatDateForServer(this.lastSearchEndingDate);

            pricesOfClosed.startingDate = startingDateForServer;
            pricesOfClosed.endingDate = endingDateForServer;

            let totalPriceRecalculated = this.waiterOfcurrentUser != null && this.waiterOfcurrentUser.ableToSeeBlackMoney ? this.getTotalPriceNotFixed(pricesOfClosed) : this.getTotalPriceForReceiptsNotFixed(pricesOfClosed);
            pricesOfClosed.totalPrice = totalPriceRecalculated;

            pricesOfClosed.amountCanceled = pricesOfClosed.amountCanceled != null ? pricesOfClosed.amountCanceled : 0;
            pricesOfClosed.amountChargedToRoom = this.waiterOfcurrentUser != null && this.waiterOfcurrentUser.ableToSeeBlackMoney ? (pricesOfClosed.amountChargedToRoom != null ? pricesOfClosed.amountChargedToRoom : 0) : 0;
            pricesOfClosed.amountOf9Vat = pricesOfClosed.amountOf9Vat != null ? pricesOfClosed.amountOf9Vat : 0;
            pricesOfClosed.amountOf13Vat = pricesOfClosed.amountOf13Vat != null ? pricesOfClosed.amountOf13Vat : 0;
            pricesOfClosed.amountOf17Vat = pricesOfClosed.amountOf17Vat != null ? pricesOfClosed.amountOf17Vat : 0;
            pricesOfClosed.amountOf24Vat = pricesOfClosed.amountOf24Vat != null ? pricesOfClosed.amountOf24Vat : 0;
            pricesOfClosed.amountOfCardReceipts = pricesOfClosed.amountOfCardReceipts != null ? pricesOfClosed.amountOfCardReceipts : 0;
            pricesOfClosed.amountOfCashReceipts = pricesOfClosed.amountOfCashReceipts != null ? pricesOfClosed.amountOfCashReceipts : 0;
            pricesOfClosed.amountOfDiscounts = pricesOfClosed.amountOfDiscounts != null ? pricesOfClosed.amountOfDiscounts : 0;
            pricesOfClosed.amountOfOnCreditReceipts = pricesOfClosed.amountOfOnCreditReceipts != null ? pricesOfClosed.amountOfOnCreditReceipts : 0;
            pricesOfClosed.amountOfSelfDeliveryReceipts = pricesOfClosed.amountOfSelfDeliveryReceipts != null ? pricesOfClosed.amountOfSelfDeliveryReceipts : 0;
            pricesOfClosed.amountOfVat = pricesOfClosed.amountOfVat != null ? pricesOfClosed.amountOfVat : 0;
            pricesOfClosed.amountOnCredit = this.waiterOfcurrentUser != null && this.waiterOfcurrentUser.ableToSeeBlackMoney ? (pricesOfClosed.amountOnCredit != null ? pricesOfClosed.amountOnCredit : 0) : (pricesOfClosed.amountOfOnCreditReceipts != null ? pricesOfClosed.amountOfOnCreditReceipts : 0);
            pricesOfClosed.amountPayedByCard = this.waiterOfcurrentUser != null && this.waiterOfcurrentUser.ableToSeeBlackMoney ? (pricesOfClosed.amountPayedByCard != null ? pricesOfClosed.amountPayedByCard : 0) : (pricesOfClosed.amountOfCardReceipts != null ? pricesOfClosed.amountOfCardReceipts : 0);
            pricesOfClosed.amountPayedByCash = this.waiterOfcurrentUser != null && this.waiterOfcurrentUser.ableToSeeBlackMoney ? (pricesOfClosed.amountPayedByCash != null ? pricesOfClosed.amountPayedByCash : 0) : (pricesOfClosed.amountOfCashReceipts != null ? pricesOfClosed.amountOfCashReceipts : 0);
            pricesOfClosed.amountTreated = this.waiterOfcurrentUser != null && this.waiterOfcurrentUser.ableToSeeBlackMoney ? (pricesOfClosed.amountTreated != null ? pricesOfClosed.amountTreated : 0) : (pricesOfClosed.amountOfSelfDeliveryReceipts != null ? pricesOfClosed.amountOfSelfDeliveryReceipts : 0);
            pricesOfClosed.totalCardtips = pricesOfClosed.totalCardtips != null ? pricesOfClosed.totalCardtips : 0;
            pricesOfClosed.amountOfExtraTax = pricesOfClosed.amountOfExtraTax != null ? pricesOfClosed.amountOfExtraTax : 0;

            pricesOfClosed.printVat = this.typeOfReport == 'ACCOUNTS' && this.isAtLeastOneRestaurantPublishesReceipt && this.waiterOfcurrentUser != null && this.waiterOfcurrentUser.ableToSeeReceiptsWithPayments;
            pricesOfClosed.showReceiptsInReport = this.isAtLeastOneRestaurantPublishesReceipt && this.waiterOfcurrentUser != null && this.waiterOfcurrentUser.ableToSeeReceiptsWithPayments;

            let restaurantId = this.restaurantsWithTableOpenings[0].id;

            await StoreApi.sendAdminSalesForPrint(restaurantId, pricesOfClosed, this.authToken, this.jwt);

            setTimeout(() => {
              this.printingUserSales = null;
            }, 1600);
          }
        }
      });

    },

    async getReports() {
      this.error = false;
      this.errorMessage = '';

      if (this.startingDate == null) {
        this.error = true;
        this.errorMessage = 'Επιλέξτε ημερομηνία αρχής έυρους αναζήτησης';
        return;
      }

      if (this.endingDate == null) {
        this.error = true;
        this.errorMessage = 'Επιλέξτε ημερομηνία τέλους έυρους αναζήτησης';
        return;
      }

      if (this.typeOfReport == 'ACCOUNTS') {
        await this.getHistoryOfAccounts();
      } else if (this.typeOfReport == 'ACTIONS') {
        await this.getHistoryOfActions();
      } else if (this.typeOfReport == 'STATS') {
        this.selectedCategories = ['0'];
        this.showMoreCategories = false;
        await this.getProductSales();
      } else if (this.typeOfReport == 'CLOSED_TABLES') {
        await this.getClosedTableOpeningsWithTotalResults();
      }

    },

    async getAdminAccountsOfUser() {
      this.searching = true;
      let restaurantIds = this.restaurantsWithTableOpenings.map(restaurant => restaurant.id)
      await UserApi.getAdminAccountsOfLoggedInUser(restaurantIds, this.authToken, this.jwt);
      this.searching = false;
    },

    async getHistoryOfAccounts() {
      this.searching = true;
      let restaurantIds = this.selectedDepartmentId == null ? this.restaurantsWithTableOpenings.map(restaurant => restaurant.id) : this.selectedDepartmentId;
      this.adminsWithSales = [];
      this.lastWaiterToSearch = null;

      let startingDateForServer = this.formatDateForServer(this.startingDate);
      let endingDateForServer = this.formatDateForServer(this.endingDate);

      this.lastSearchStartingDate = this.startingDate;
      this.lastSearchEndingDate = this.endingDate;

      let tableIds = [];
      if (this.selectedTableId == null) {
        let availableTables = this.tablesToSearch;
        tableIds = availableTables.map(table => table.id);
      } else {
        tableIds.push(this.selectedTableId);
      }

      let userIds = [];
      if (this.waiterToSearch != null) {
        this.lastWaiterToSearch = this.waiterToSearch;
        userIds.push(this.waiterToSearch);
      }

      let apiResponse = await Promise.all([StoreApi.getPricesForClosedTables(restaurantIds, tableIds, userIds, startingDateForServer, endingDateForServer, this.authToken, this.jwt), StoreApi.getTotalAmountOfClosedTables(restaurantIds, tableIds, userIds, startingDateForServer, endingDateForServer, this.authToken, this.jwt)]).then(data => {
        return {
          prices: data[0],
          totalAmountOfClosed: data[1]
        }
      });

      if (this.waiterToSearch == null && this.waiterOfcurrentUser && this.waiterOfcurrentUser.orderHistoryScope != 'PERSONAL_TODAY') {
        this.waiters.forEach(waiter => userIds.push(waiter.userId));
        let adminsWithSalesFromServer = await StoreApi.getPricesForClosedTablesCombined(restaurantIds, tableIds, userIds, startingDateForServer, endingDateForServer, this.authToken, this.jwt)

        for (let adminWithSales of adminsWithSalesFromServer) {
          let pricesOfAdmin = adminWithSales.prices;
          if ((pricesOfAdmin.amountPayedByCash != null && pricesOfAdmin.amountPayedByCash > 0) || (pricesOfAdmin.amountPayedByCard != null && pricesOfAdmin.amountPayedByCard > 0) || (pricesOfAdmin.amountOnCredit != null && pricesOfAdmin.amountOnCredit > 0) || (pricesOfAdmin.amountChargedToRoom != null && pricesOfAdmin.amountChargedToRoom > 0) || (pricesOfAdmin.amountOfDiscounts != null && pricesOfAdmin.amountOfDiscounts > 0) || (pricesOfAdmin.amountTreated != null && pricesOfAdmin.amountTreated > 0) || (pricesOfAdmin.amountCanceled != null && pricesOfAdmin.amountCanceled > 0) || (pricesOfAdmin.amountOfCashReceipts != null && pricesOfAdmin.amountOfCashReceipts > 0) || (pricesOfAdmin.amountOfCardReceipts != null && pricesOfAdmin.amountOfCardReceipts > 0) || (pricesOfAdmin.amountOfOnCreditReceipts != null && pricesOfAdmin.amountOfOnCreditReceipts > 0) || (pricesOfAdmin.amountOfSelfDeliveryReceipts != null && pricesOfAdmin.amountOfSelfDeliveryReceipts > 0)) {
            this.adminsWithSales.push(adminWithSales);
          }
        }
      }

      this.pricesOfClosed = apiResponse.prices;
      this.totalAmountOfClosed = apiResponse.totalAmountOfClosed;
      this.searching = false;
    },

    async getHistoryOfActions() {
      this.searching = true;
      let restaurantIds = this.selectedDepartmentId == null ? this.restaurantsWithTableOpenings.map(restaurant => restaurant.id) : this.selectedDepartmentId;
      this.adminsWithSales = [];
      this.lastWaiterToSearch = null;

      let startingDateForServer = this.formatDateForServer(this.startingDate);
      let endingDateForServer = this.formatDateForServer(this.endingDate);

      this.lastSearchStartingDate = this.startingDate;
      this.lastSearchEndingDate = this.endingDate;

      let tableIds = [];
      if (this.selectedTableId == null) {
        let availableTables = this.tablesToSearch;
        tableIds = availableTables.map(table => table.id);
      } else {
        tableIds.push(this.selectedTableId);
      }

      let userIds = [];
      if (this.waiterToSearch != null) {
        this.lastWaiterToSearch = this.waiterToSearch;
        userIds.push(this.waiterToSearch);
      }

      this.pricesOfClosed = await StoreApi.getPricesForActions(restaurantIds, tableIds, userIds, startingDateForServer, endingDateForServer, this.authToken, this.jwt);

      if (this.waiterToSearch == null && this.waiterOfcurrentUser && this.waiterOfcurrentUser.orderHistoryScope != 'PERSONAL_TODAY') {
        this.waiters.forEach(waiter => userIds.push(waiter.userId));
        let adminsWithSalesFromServer = await StoreApi.getPricesForActionsCombined(restaurantIds, tableIds, userIds, startingDateForServer, endingDateForServer, this.authToken, this.jwt)

        for (let adminWithSales of adminsWithSalesFromServer) {
          let pricesOfAdmin = adminWithSales.prices;
          if ((pricesOfAdmin.amountPayedByCash != null && pricesOfAdmin.amountPayedByCash > 0) || (pricesOfAdmin.amountPayedByCard != null && pricesOfAdmin.amountPayedByCard > 0) || (pricesOfAdmin.amountOnCredit != null && pricesOfAdmin.amountOnCredit > 0) || (pricesOfAdmin.amountChargedToRoom != null && pricesOfAdmin.amountChargedToRoom > 0) || (pricesOfAdmin.amountOfDiscounts != null && pricesOfAdmin.amountOfDiscounts > 0) || (pricesOfAdmin.amountTreated != null && pricesOfAdmin.amountTreated > 0) || (pricesOfAdmin.amountCanceled != null && pricesOfAdmin.amountCanceled > 0) || (pricesOfAdmin.amountOfCashReceipts != null && pricesOfAdmin.amountOfCashReceipts > 0) || (pricesOfAdmin.amountOfCardReceipts != null && pricesOfAdmin.amountOfCardReceipts > 0) || (pricesOfAdmin.amountOfOnCreditReceipts != null && pricesOfAdmin.amountOfOnCreditReceipts > 0) || (pricesOfAdmin.amountOfSelfDeliveryReceipts != null && pricesOfAdmin.amountOfSelfDeliveryReceipts > 0)) {
            this.adminsWithSales.push(adminWithSales);
          }
        }
      }

      this.searching = false;
    },

    async getProductSales() {
      this.searching = true;

      let startingDateForServer = this.formatDateForServer(this.startingDate);
      let endingDateForServer = this.formatDateForServer(this.endingDate);

      let days = Math.round((this.endingDate - this.startingDate) / (1000 * 60 * 60 * 24));

      if (days >= 125) {
        this.$confirm({
          message: `Το μέγιστο έυρος αναζήτησης για στατιστικά πωλήσεων είναι 4 μήνες`,
          button: {
            yes: 'ΟΚ'
          },
          callback: async confirm => {
            if (confirm) {
            } else {
            }
          }
        });
        this.searching = false;
        return;
      }

      let selectedUserId = this.orderOrigin == 'CUSTOMER' ? null : this.waiterToSearch;
      let response = await StoreApi.getProductSales(this.selectedDepartmentId, this.typeOfSales, startingDateForServer, endingDateForServer, selectedUserId, this.selectedTableId, this.orderOrigin, this.authToken, this.jwt);

      this.itemStats = response.productSales;
      this.amountOfOrders = response.amountOfOrders;

      this.searching = false;
    },

    setTitle() {
      try {
        document.title = this.title;
      } catch (error) {
        console.log("Could not set title");
      }
    }
  },
};
</script>

<style scoped>
.margin-top-0 {
  margin-top: 0px !important;
}

.margin-top-12 {
  margin-top: 12px !important;
}

.total-orders-results-container {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  border-bottom: 1px solid rgba(116, 135, 150, 0.2);
  margin-left: 0px;
  padding-left: 8px;
}

.selected-categories-outer-container {
  margin-top: 8px !important;
  margin-bottom: 6px !important;
  border-bottom: 1px solid rgba(116, 135, 150, 0.2);
  margin-left: 0px;
  padding-left: 8px;
}

.selected-categories-inner-container {
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
}

.category-to-select {
  display: flex;
  align-items: center;
  margin-bottom: 2px;
}

.show-more-btn {
  cursor: pointer;
  color: #007bff;
  font-size: 14px;
  margin-left: 2px;
  font-weight: 600;
  margin-top: 6px;
  user-select: none;
  text-decoration: underline;
}

.product-and-subs-container {
  display: flex;
  flex-direction: column;
}

.subs-container {
  font-size: 13px;
  color: #575757;
  margin-left: 0px;
  display: flex;
  flex-direction: column;
}

::v-deep .pagination {
  display: inline-block;
  padding-left: 0;
  margin: 20px 0;
  border-radius: 4px;
}

::v-deep .pagination > li {
  display: inline;
}

::v-deep .pagination > li:first-child > a,
::v-deep .pagination > li:first-child > span {
  margin-left: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

::v-deep .pagination > .disabled > a,
::v-deep .pagination > .disabled > a:focus,
::v-deep .pagination > .disabled > a:hover,
::v-deep .pagination > .disabled > span,
::v-deep .pagination > .disabled > span:focus,
::v-deep .pagination > .disabled > span:hover {
  color: #777;
  cursor: not-allowed;
  background-color: #fff;
  border-color: #ddd;
}

::v-deep .pagination > li > a,
::v-deep .pagination > li > span {
  position: relative;
  float: left;
  padding: 6px 12px;
  margin-left: -1px;
  line-height: 1.42857143;
  color: #337ab7;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #ddd;
}

::v-deep .pagination > .active > a,
::v-deep .pagination > .active > a:focus,
::v-deep .pagination > .active > a:hover,
::v-deep .pagination > .active > span,
::v-deep .pagination > .active > span:focus,
::v-deep .pagination > .active > span:hover {
  z-index: 3;
  color: #fff;
  cursor: default;
  background-color: #337ab7;
  border-color: #337ab7;
}

table {
  border-collapse: collapse;
}

th {
  border: 1px solid #dddddd;
  padding: 8px;
  color: #003340;
  font-size: 15px;
  white-space: nowrap;
}

td {
  border: 1px solid #dddddd;
  padding: 8px;
  font-size: 14px;
}

.font-italic {
  font-style: italic;
}

.mt-1 {
  margin-top: 4px;
}

.text-success {
  color: #5cb85c;
}

.text-info {
  color: #5bc0de;
}

.text-warning {
  color: #f0ad4e;
}

.text-dark {
  color: #343a40;
}

.text-primary {
  color: #007bff;
}

.product-header {
  text-align: left;
  max-width: 170px;
}

.text-center {
  text-align: center;
}

.all-users-and-print-container {
  display: flex;
  justify-content: space-between;
}

.user-and-print-container {
  margin-top: 8px;
  margin-bottom: 4px;
  display: flex;
  justify-content: space-between;
}

.print-sales-button {
  color: white;
  background-color: #198b4a;
  margin-bottom: 6px;
  margin-right: 6px;
}

.action-button {
  padding: 4px 8px 4px 8px;
  border-radius: 6px;
  cursor: pointer;
}

#history-screen {
  margin: 0px;
  box-sizing: border-box;
  padding: 0px;
  overflow-x: hidden;
  background: #fcfcfc;
  min-height: 100vh;
  z-index: 0;
  overflow-x: hidden !important;
}

#banner {
  position: relative;
  width: 100vw;
  height: 55vh;
  min-height: 220px;
}

#banner-image {
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

#actions-buttons-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: 8px;
  margin-top: 10px;
  margin-bottom: 6px;
}

#search-history-btn {
  color: #ffffff;
  background-color: #198b4a;
  border-radius: 6px;
  padding: 4px 14px 4px 14px;
  font-size: 15px;
}

#store-info {
  position: absolute;
  top: 15%;
  right: 5%;
  width: 30%;
  min-width: 400px;
  background: white;
  border-radius: 18px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.36), 2px 2px 4px rgba(0, 0, 0, 0.48);
}

#store {
  cursor: unset;
}

#error-message {
  margin-left: 10px;
  margin-top: 4px;
  margin-bottom: 0px;
  font-size: 14px;
  font-weight: 600;
  color: #d9534f;
}

#history-results-container {
  min-height: 600px !important;
}

#type-of-reports-container {
  display: flex;
  align-items: center;
  overflow-x: scroll;
  scrollbar-width: none;
  margin-top: 2px;
  margin-bottom: 8px;
  margin-left: 8px;
}

.report-type-selection-button {
  padding: 5px 5px 5px 5px;
  border-radius: 4px;
  cursor: pointer;
  color: #0d6efd;
  background-color: #ffffff;
  border: 1px solid #0d6efd;
  font-size: 13px;
  font-weight: 600;
  margin-top: 0px;
  margin-right: 6px;
  white-space: nowrap;
}

.selected-report-type {
  color: #ffffff !important;
  background-color: #0d6efd !important;
}

#general-errors-container {
  min-height: 600px !important;
  padding-top: 10px;
  padding-left: 8px;
  padding-right: 8px;
}

.info-message {
  font-size: 15px;
  font-weight: 600;
  color: #003340;
}

.prices-results-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-left: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(116, 135, 150, 0.2);
}

.receipts-results-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-left: 10px;
  margin-top: 10px;
  border-bottom: 1px solid rgba(116, 135, 150, 0.2);
  padding-bottom: 10px;
}

#statistics-results-container {
  width: 100%;
}

#closed-tables-section {
  display: flex;
  flex-direction: column;
  align-items: center;
}

#closed-tables-results-container {
  width: 98%;
}

#connected-user-container {
  margin-bottom: 2px;
  margin-left: 8px;
  margin-top: 6px;
  font-size: 15px;
  font-weight: 600;
  color: #003340;
}

#name-of-connected-user {
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #198b4a !important;
}

#select-filter-container {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  margin-bottom: 1vh;
  border-bottom: 1px solid rgba(116, 135, 150, 0.2);
  padding: 2x 0 7.5px 0;
  color: black;
}

.label-and-name {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  justify-content: flex-start;
  margin-top: 8px;
  margin-left: 8px;
}

.stats-headers {
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-content: flex-start;
  margin-top: 0px;
  margin-left: 8px;
}

.filter-title {
  font-size: 15px;
  font-weight: 700;
}

.label {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

select {
  display: flex;
  align-self: center;
  justify-self: center;
  -webkit-appearance: auto !important;
  box-shadow: inset 0px 0px 2px rgba(116, 135, 150, 0.2),
    inset 1px 1px 2px rgba(116, 135, 150, 0.36);
  border-radius: 6px;
  margin-bottom: 0.5rem;
  margin-left: 7px;
  padding: 2px;
  color: #198b4a !important;
  font-weight: bold;
  background: #f7f7f7;
}

.amount-of-closed {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 0px;
}

.admin-with-sales-container {
  border-top: 6px solid #003340;
}

.all-users {
  margin-bottom: 0px;
  font-size: 22px;
  font-weight: 700;
  color: #003340;
}

.name-of-user {
  margin-bottom: 0px;
  font-size: 24px;
  font-weight: 700;
  color: #003340;
  padding-left: 10px;
}

.total-price-of-closed {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
}

.payment-method-price {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 4px;
}

.receipts-separator {
  border-color: #d8d8d8;
  background-color: #d8d8d8;
}
@media screen and (max-width: 800px) {
  select {
    font-size: 14.5px;
  }
}
@media screen and (max-width: 300px) {
  select {
    font-size: 12px;
  }
}

option {
  color: #198b4a !important;
  font-weight: 600;
}

#upper-bar {
  position: absolute;
  top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 48px;

  padding-right: 1%;
}

#profile-and-cart {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 48px;
}

#language-select {
  position: absolute;
  right: 200px;
  top: 8px;
  cursor: pointer;
}

.language-position-in-login {
  right: 159px !important;
  z-index: 202;
}

#enter-prompt {
  position: absolute;
  top: 8px;
  right: 88px !important;
  z-index: 201;
}

#profile-dropdown {
  position: absolute;
  top: 0px;
  right: 88px !important;
  z-index: 201;
}

#back-to-services {
  position: fixed;
  left: 80px;
  box-shadow: 3px 4px 8px rgba(0, 0, 0, 0.32), 3px 4px 8px rgba(0, 0, 0, 0.46);
}

#logo-container {
  background: white !important;
  /* height: 45px; */
  margin-left: 80px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  justify-content: center;
  padding: 0px 16px 0px 12px;
  border-radius: 12px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.24), 2px 2px 4px rgba(0, 0, 0, 0.36);
}

#logo {
  cursor: pointer;
  height: 40px;
  width: auto;
}

#link-to-landing {
  text-decoration: none;
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 204;
  opacity: 1;
  transition: 0.67s;
}

.hide {
  visibility: hidden;
  display: none;
}

.low-visibility {
  opacity: 0.5;
}

#loading-mask {
  position: fixed;
  top: 0;
}

@media screen and (max-width: 1018px) {
  #language-select {
    left: unset;
    top: 5px !important;
    right: 20px;
    cursor: pointer;
  }

  .language-position-in-login {
    right: 20px !important;
    z-index: 202;
  }

  .no-bottom-margin {
    margin-bottom: 0px !important;
  }

  #profile-dropdown {
    right: 20px !important;
  }

  .profile-dropdown-with-lang-select {
    top: 58px !important;
  }

  .profile-dropdown-without-lang-select {
    top: 2px !important;
  }

  #enter-prompt {
    right: 20px !important;
    margin: 0;
  }

  .enter-prompt-with-lang-select {
    top: 56px !important;
  }

  .enter-prompt-without-lang-select {
    top: 5px !important;
  }

  #back-to-services {
    left: 20px;
  }

  #logo-container {
    min-width: 95px !important;
    justify-content: flex-start;
    margin-left: 20px;
  }

  #logo {
    height: 33px;
  }

  #banner {
    height: 40vh;
  }

  #store-info {
    top: 165px;
    width: 90%;
    left: 5%;
    min-width: 200px;
    max-height: 112px;
  }

  #upper-bar {
    top: 15px;
    height: unset;
  }
}

@media screen and (max-width: 350px) {
  #store-info {
    top: 140px;
  }

  th {
    font-size: 14px;
  }

  td {
    font-size: 13px;
  }

  .product-header {
    max-width: 145px;
  }
}

@media screen and (max-width: 1018px) {
  #banner {
    height: 290px !important;
  }
}

@media screen and (max-width: 530px) {
  #banner {
    height: 280px !important;
  }
}

@media screen and (max-width: 350px) {
  #banner {
    height: 250px !important;
  }
}

@media screen and (max-width: 330px) {
  #banner {
    height: 235px !important;
  }
}

@media screen and (max-width: 285px) {
  th {
    font-size: 13px;
  }

  td {
    font-size: 12px;
  }

  .product-header {
    max-width: 120px;
  }
}
</style>
